// src/pages/NotFoundPage.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css'; // We'll create this CSS file next

const NotFoundPage = () => {
  return (
    <main className="not-found-page">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>Sorry, the page you were looking for does not exist or has been moved.</p>
      <Link to="/" className="back-home-link">
        Go back to Homepage
      </Link>
    </main>
  );
};

export default NotFoundPage;